class Lightbox {
    constructor(elem) {
		this.elem = elem
		this.body = document.querySelector('body')
		this.elem.on('click', () => this.openLightbox())
	}
	
	openLightbox() {
		this.lightbox = this.createLightbox()
		document.body.insertBefore(this.lightbox, this.body.childNodes[0])
		this.bindCloseButton()
		this.body.classList.add('no-scroll')
	}
	
	closeLightbox() {
		const lightbox = document.getElementById(this.id)
		this.body.removeChild(lightbox)
		this.body.classList.remove('no-scroll')
	}
	
	bindCloseButton() {
		this.closeButton = document.querySelector('.lightbox-close')
		this.closeButton.addEventListener('click', () => this.closeLightbox())
	}
	
	createLightbox() {
		var imageSrc = this.elem.find('img')[0].src
        var imageUrl = imageSrc.slice(0, imageSrc.indexOf('?preset'))

        if (this.elem.hasClass('adaptive-lightbox')) {
			imageSrc = this.elem.parent()[0].dataset['lightboxImage'] || this.elem.find('source')[0].srcset
            imageUrl = imageSrc
        }

		const lightbox = document.createElement('div')
		this.id = new Date().getTime()
		lightbox.id = this.id
		lightbox.addEventListener('click', () => this.closeLightbox())

		lightbox.classList.add('lightbox-modal')
		lightbox.innerHTML = `
			<img src=${imageUrl}></img>
			<button class="lightbox-close">&times</button>
		`
		return lightbox
	}
}

export default Lightbox;